import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";
import { Tooltip, Box, IconButton } from "@material-ui/core";
import { get } from "lodash";
import { permissionsSet } from "../../../../recoil/LoggedInUserDetail/selector";
import {
  EDIT,
  USERPROFILE,
  USERS
} from "../../../../constants/routeConstants";
import { useStyles } from "../styles";
import { manageUserCoachRoleMutation } from "../../../../graphQL/mutation/manageUserCoachRole";
import { useMutation } from "@apollo/client";
import { useToast } from "../../../../hooks/useToast";
import { Auth } from "aws-amplify";
import ConfirmationModal from "Components/modal/Modal/ConfirmationModal";
import { GrantCoachAccess, RevokeCoachAccess } from "src/assets/";
import GenericActionPopover from "Components/formControls/ActionsDropdown/GenericActionPopover";
import { Check, NotInterested } from "@material-ui/icons";

const UserAction = ({
  colProps,
  setUserGridData,
  userGridData,
  toggleDeactiveModal
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const userRole = get(Auth, "user.attributes.custom:role");

  const permissions = useRecoilValue(permissionsSet);

  const [openModal, setOpenModal] = useState(false);
  const [modalObj, setModalObj] = useState({});
  const [loader, setLoader] = useState(false);
  const [menuList, setMenuList] = useState([]);

  const [manageUserCoachRole] = useMutation(manageUserCoachRoleMutation);

  const toaster = useToast();

  const coachRoles = [
    "Coach",
    "Departmentcoach",
    "Executivedepartmentcoach",
    "Externalcoach"
  ];
  const createUser = get(permissions, "createUsers", false);
  const userBasedPermissions = get(permissions, "userBasedPermissions", {});
  const userManagement = get(permissions, "userManagement", {});
  const createAdminUser = get(permissions, "createAdminUser", {});
  const seeEditIcon = get(createAdminUser, "modifyAccess", false); //&& colProps.dataItem.role === "CompanyAdmin"
  const coachAccessHandler = type => {
    let toastMessage = "Coach access revoked";
    let title = "Revoke coach access";
    let bodyText = "Are you sure you want to revoke the coach access?";
    let icon = <NotInterested />;

    if (type === "Grant") {
      toastMessage = "Coach access granted";
      title = "Grant coach access";
      bodyText = "Are you sure you want to grant the coach access?";
      icon = <Check style={{ width: 45, height: 45 }} />;
    }

    setModalObj({
      type,
      toastMessage,
      title,
      bodyText,
      icon
    });
    setOpenModal(true);
  };

  const confirmationHandler = () => {
    setLoader(true);
    manageUserCoachRole({
      variables: {
        coachRoleActionType: get(modalObj, "type"),
        userIds: [get(colProps, "dataItem.id")]
      }
    })
      .then(({ data }) => {
        const userData = userGridData.map(item => {
          return {
            ...item,
            ...(get(item, "id") === get(data, "manageUserCoachRole.0.id") && {
              isCoach: !item.isCoach
            })
          };
        });
        setUserGridData(userData);
        setLoader(false);
        setOpenModal(false);
        toaster.success({ message: get(modalObj, "toastMessage") });
      })
      .catch(error => {
        toaster.error({ message: "Error" });
        setLoader(false);
        setOpenModal(false);
      });
  };

  useEffect(() => {
    checkPermissionOfMenu();
  }, []);

  const checkPermissionOfMenu = () => {
    const _showMenu = {
      userProfileCondition:
        get(createUser, "readAccess", false) ||
        get(createUser, "modifyAccess", false) ||
        get(userBasedPermissions, "writeAccess", false) ||
        get(userBasedPermissions, "modifyAccess", false) ||
        get(userManagement, "writeAccess", false) ||
        get(userManagement, "modifyAccess", false),

      Edit:
        (colProps.dataItem.role === "Company Admin" &&
          get(createAdminUser, "modifyAccess", false)) ||
        (colProps.dataItem.role !== "Company Admin" &&
          get(createUser, "modifyAccess", false))
    };

    const menuListItem = [];
    get(_showMenu, "userProfileCondition", true) &&
      menuListItem.push({
        type: "detail",
        isLink: true,
        link: `${USERPROFILE}/${colProps.dataItem.id}`,
        label: "Details"
      });
    get(_showMenu, "Edit", true) &&
      menuListItem.push({
        type: "edit",
        isLink: true,
        link: `${USERS}${EDIT}/${colProps.dataItem.id}`,

        label: "Edit"
      });

    userRole == "CompanyAdmin" &&
      get(colProps, "dataItem.status") === "Active" &&
      menuListItem.push({
        type: "reset",
        isLink: false,
        onClick: () =>
          toggleDeactiveModal("RESETPASSWORD", colProps.dataItem.id),
        label: t("login.resetPassword")
      });
    setMenuList(menuListItem);
  };

  return (
    <td>
      <Box
        className={classes.gridAction}
        display="flex"
        alignItems="center"
        justifyContent="flex-end"
        width="85px"
      >
        {get(colProps, "dataItem.status") === "Active" &&
          !coachRoles.includes(
            get(colProps, "dataItem.role").replace(/\s+/g, "")
          ) &&
          !get(colProps, "dataItem.isCoach") &&
          userRole === "CompanyAdmin" ? (
          <Tooltip title={"Grant coach access"}>
            <IconButton
              className="mr10"
              size="small"
              data-testid="coachAccessHandler"
              onClick={() => coachAccessHandler("Grant")}
              disabled={false}
            >
              <RevokeCoachAccess />
            </IconButton>
          </Tooltip>
        ) : get(colProps, "dataItem.status") === "Active" &&
          !coachRoles.includes(
            get(colProps, "dataItem.role").replace(/\s+/g, "")
          ) &&
          get(colProps, "dataItem.isCoach") &&
          userRole === "CompanyAdmin" ? (
          <Tooltip title={"Revoke coach access"}>
            <IconButton
              size="small"
              className="mr10"
              data-testid="coachAccessHandler"
              onClick={() => coachAccessHandler("Revoke")}
              disabled={false}
            >
              <GrantCoachAccess />
            </IconButton>
          </Tooltip>
        ) : null}

        <GenericActionPopover menuList={menuList} />
        {openModal && (
          <ConfirmationModal
            loader={loader}
            open={openModal}
            icon={get(modalObj, "icon", "")}
            title={get(modalObj, "title", "")}
            handleClose={() => setOpenModal(false)}
            handleOk={() => confirmationHandler()}
            body={get(modalObj, "bodyText", "")}
          />
        )}
      </Box>
    </td>
  );
};

export default UserAction;
